import { Icon, IconProps } from '@iconify/react';
import React, { memo } from 'react';

const MemoizedIcon = memo((props: IconProps) => {
  return <Icon {...props} />;
});

export default MemoizedIcon;
